<mat-card>
    <mat-card-header>
        <mat-card-title class="mat-card-title-custom">{{'total_money_sms.card_title' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'report_components.filter_title' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form" class="pb-3">
                    <div class="row">
                        <!-- Chu kỳ -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'total_contract_report.time_period' | translate}}</mat-label>
                                <mat-select #timePeriod (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                                            (focus)="commonService.openComboBox(checkFocus, timePeriod)" id="timePeriod" name="timePeriod"
                                            formControlName="timePeriod" required>
                                    <mat-option value="day" selected
                                                (click)="this.commonService.closeDropdownList(this.timePeriod)">
                                        {{'analysis.analysis_report_consumption.options.day' | translate}}</mat-option>
                                    <mat-option value="week"
                                                (click)="this.commonService.closeDropdownList(this.timePeriod)">
                                        {{'analysis.analysis_report_consumption.options.week' | translate}}</mat-option>
                                    <mat-option value="month"
                                                (click)="this.commonService.closeDropdownList(this.timePeriod)">
                                        {{'analysis.analysis_report_consumption.options.month' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (từ ngày) -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'total_contract_report.from_date' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdTimeFrom"
                                       name="fromDate" #pickerInput formControlName="fromDate"
                                       (dateChange)="changeDatePickerFromDate($event);"
                                       maxlength="200" (focus)="dateErr = 'toDate'" autocomplete="off" required/>
                                <mat-datepicker-toggle matSuffix [for]="createdTimeFrom">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdTimeFrom></mat-datepicker>
                                <mat-error *ngIf="formControls['fromDate'].invalid && (formControls['fromDate'].dirty || formControls['fromDate'].touched)">
                                        <span *ngIf="formControls['fromDate'].invalid">
                                          {{getErrorDateMessageRange(pickerInput.value)}}
                                        </span>
                                  <span *ngIf="getErrorDateMessageRange(pickerInput.value)==null">
                                          {{'validation.empty_of_date_consumption' | translate}}
                                        </span>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (đến ngày) -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'total_contract_report.to_date' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdTimeToRef"
                                       (dateChange)="changeDatePickerToDate($event)"
                                       name="toDate" #pickerInput1 formControlName="toDate"
                                       maxlength="200" (focus)="dateErr = 'toDate'" autocomplete="off" required/>
                                <mat-datepicker-toggle matSuffix [for]="createdTimeToRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdTimeToRef></mat-datepicker>
                                <mat-error *ngIf="formControls['toDate'].invalid && (formControls['toDate'].dirty || formControls['toDate'].touched)">
                                        <span *ngIf="formControls['toDate'].invalid">
                                          {{getErrorDateMessageRange(pickerInput1.value)}}
                                        </span>
                                  <span *ngIf="getErrorDateMessageRange(pickerInput1.value)==null">
                                          {{'validation.empty_of_date_consumption' | translate}}
                                        </span>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="offset-4 col-4"
                         *ngIf="isShowWarningSelectedFromDate">
                            <mat-error>
                                <span *ngIf="formControls['timePeriod'].value === 'day'">{{ 'search_form.limit_day_select_create_date' | translate
                                  }}</span>
                                <span *ngIf="formControls['timePeriod'].value === 'week'">{{ 'search_form.limit_week_select_create_date' | translate
                                  }}</span>
                                <span *ngIf="formControls['timePeriod'].value === 'month'">{{ 'search_form.limit_month_select_create_date' | translate
                                  }}</span>
                              </mat-error>
                        </div>
                        <div class="offset-8 col-4"
                         *ngIf="isShowWarningSelectedToDate">
                            <mat-error>
                                <span *ngIf="formControls['timePeriod'].value === 'day'">{{ 'search_form.limit_day_select_create_date' | translate
                                  }}</span>
                                <span *ngIf="formControls['timePeriod'].value === 'week'">{{ 'search_form.limit_week_select_create_date' | translate
                                  }}</span>
                                <span *ngIf="formControls['timePeriod'].value === 'month'">{{ 'search_form.limit_month_select_create_date' | translate
                                  }}</span>
                              </mat-error>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
    <div class="row mt-3" style="margin-bottom: 15px;">
        <div class="col-lg-12 d-flex justify-content-center">
            <button mat-raised-button color="primary" (click)="onExportReport()"
                    [disabled]="!form.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">receipt_long</mat-icon>
                {{'total_contract_report.title_btn' | translate}}
            </button>
        </div>
    </div>
</mat-card>
<app-history-report [mode]="mode" [formExport]="exportForm" (filterForm)="filterForm($event)"></app-history-report>
<ng4-loading-spinner *ngIf="showSpinner" [threshold]="1000" [timeout]="100000" [zIndex]="9999"></ng4-loading-spinner>
